import React, { useState } from 'react';
import { Typography, TextField, Select, MenuItem, Button, FormControl, InputLabel, Paper } from "@mui/material";
import { useGroupContext } from '../Groups/useGroupContext';

const CategoryForm = ({ isEdit = false, data = {}, onSubmit }) => {
    const { isGroupMode, currentGroupName } = useGroupContext();
    const [formData, setFormData] = useState(() => {
    const defaults = {
      name : "",
      type: "EXPENSE"
    };
    const merged = {...defaults, ...data};
    return merged;

  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Paper sx={{ padding: 3, maxWidth: "500px", margin: "auto", mt: 3 }}>
      <Typography variant="h6">{isEdit ? "Edit Category" : "Add Category"}</Typography>
      {isGroupMode && (
            <Typography variant="caption" display="block" color="textSecondary">
              for {currentGroupName}
            </Typography>
          )}
      <form onSubmit={handleSubmit}>
         <TextField
                  label="Name"
                  name="name"
                  fullWidth
                  value={formData.name || ""}
                  onChange={handleChange}
                  sx={{ mt: 2 }}
                />
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Category Type</InputLabel>
          <Select
            name="type"
            value={formData.type || "EXPENSE"}
            onChange={handleChange}
            displayEmpty
            label="Category Type"
          >
            <MenuItem value="EXPENSE">Expense</MenuItem>
            <MenuItem value="INCOME">Income</MenuItem>
            <MenuItem value="INVESTMENT">Investment</MenuItem>
          </Select>
        </FormControl>

      <Button type="submit" variant="contained" size="small" fullWidth sx={{ mt: 2 }}>
          {isEdit ? "Update Category" : "Add Category"}
        </Button>
      </form>
    </Paper>
  );
};

export default CategoryForm;